<div class="autocomplete page-autocomplete">
  <form autocomplete="off" [formGroup]="autoCompleteForm">

    <mat-form-field [appearance]="appearance" class="w-100">
      <mat-label translate>{{label}}</mat-label>

      <input type="text" matInput formControlName="pageTitle"
        [placeholder]="placeholder | translate"
        [matAutocomplete]="autoComplete" [required]="required">

      <span matSuffix *ngIf="loading$ | async">
        <span class="spinner-border spinner-border-lg text-muted" role="status"></span>
      </span>

      <mat-autocomplete autoActiveFirstOption #autoComplete="matAutocomplete" [displayWith]="displayWithFn">
        <mat-option *ngFor="let prediction of predictions$ | async" [value]="prediction"(onSelectionChange)="selectItem($event)">
          <div fxLayout="row" fxLayoutAlign="start center">
            <div>
              <span class="d-block autocomplete-field title">{{prediction?.pageTitle}}</span>
              <span class="d-block autocomplete-field subtitle">{{prediction?.pageDescription}}</span>
            </div>
          </div>
        </mat-option>
      </mat-autocomplete>

      <mat-error class="error-field" *ngIf="required && inputField?.touched" translate>Please select page type</mat-error>
    </mat-form-field>

    <p class="mt-n3 my-1 text-danger" *ngIf="noPrediction && inputFieldValue?.length > 2" @fadeIn>
      <span translate>No pages found with keyword </span>
      <strong>"{{ inputFieldValue }}"</strong>
    </p>
  </form>
</div>
